  <script setup lang="ts">
  // import { statusEventBus } from '@/utils/eventBus';
  import { useI18n } from 'vue-i18n';

  import BaseButton from '@/components/Base/BaseButton.vue';
  import { VideoState } from '@/types/VideoState';
  import { computed } from 'vue';

  const { t } = useI18n();

  const props = defineProps<{
    state: VideoState;
  }>();

  const callStatusVariant = computed(() => {
    switch (props.state) {
      case VideoState.NeverConnected:
      case VideoState.Disconnected:
        return 'danger';
      case VideoState.Connecting:
        return 'primary';
      case VideoState.Connected:
        return 'success';
      case VideoState.Paused:
        return 'primary';
      case VideoState.Failed:
      case VideoState.Closed:
        return 'danger';
      default:
        return 'primary';
    }
  });

  const callStatusIcon = computed(() => {
    switch (props.state) {
      case VideoState.Paused:
        return 'end-video';
      default:
        return 'video';
    }
  });


</script>

<template>
  <BaseButton :left-icon="callStatusIcon" :variant="callStatusVariant" size="small">
    {{ t('video.state.' + state) }}
  </BaseButton>
</template>

<style lang="css" scoped></style>
